@let isLoading = isLoading$ | async;

<div class="flex justify-between items-center px-4 py-2">
  <mat-form-field
    appearance="outline"
    class="no-padding"
    [class.flex-grow-1]="hideAddNewButton()"
    [class.w-full]="hideAddNewButton()"
  >
    <mat-label>{{ filterLabel() }}</mat-label>
    <fa-icon class="mat-primary si-icon" matPrefix [icon]="['fal', 'magnifying-glass']"></fa-icon>
    <input matInput type="text" [formControl]="searchControl" [placeholder]="filterPlaceholder()">
  </mat-form-field>
  @if (!hideAddNewButton()) {
    <div [matTooltip]="newTooltip()">
      <button
        matButton="filled"
        [disabled]="isLoading || !isOpsAdminOrAdmin()"
        (click)="onEditCreateBuyerPersona()"
      >
        <div class="flex items-center">
          <fa-icon matPrefix class="si-icon mr-3" [icon]="['fal', 'plus']"></fa-icon>
          <span>Add New</span>
        </div>
      </button>
    </div>
  }
</div>

@if (!hasLoadedOnce()) {
  <div class="p-12 flex justify-center items-center w-full">
    <mat-spinner></mat-spinner>
  </div>
} @else {
  @if (noDataTemplate && !isLoading && hasLoadedOnce() && !hasAnyData()) {
    <ng-container [ngTemplateOutlet]="noDataTemplate.templateRef"></ng-container>
  } @else {
    <app-data-table
      infiniteScroll
      [isLoading]="isLoading"
      [isLoadMore]="isLoadingMore$ | async"
      [data]="buyerPersonaList"
      [columns]="columns"
      [customSorting]="true"
      [infiniteScrollDistance]="0.5"
      [infiniteScrollThrottle]="600"
      [scrollWindow]="false"
      [sortActive]="defaultParams.sortBy"
      [sortDirection]="defaultParams.sortDirection"
      (scrolled)="onLoadMore()"
      (sortingChanged)="onSortingChanged($event)"
    >
      <ng-container *cellTemplate="let row of 'nameTpl'">
        <span
          class="two-line-wrap"
          [matTooltip]="row.name"
        >{{row.name}}</span>
      </ng-container>

      <ng-container *cellTemplate="let row of 'selectionsTpl'">
        <div class="custom-two-line-wrap">
          <app-buyer-personas-clamp [lines]="2">
            <div *ngFor="let line of (row.query | buyingPersonasDisplayQuery)">
              <strong>{{ line.label }}:</strong> {{ line.value }}
            </div>
          </app-buyer-personas-clamp>
        </div>
      </ng-container>

      <ng-container *cellTemplate="let row of 'actionsTpl'; let index = index;">
        <div class="inline-block" [matTooltip]="row | buyerPersonasActionTooltip : isOpsAdminOrAdmin() : 'Edit'">
          <button
            mat-icon-button
            class="mat-primary"
            [disabled]="((DELETE_LOADING_TAG | isLoadingById: row.id) | async) || row.isLocked || !isOpsAdminOrAdmin()"

            (click)="onEditCreateBuyerPersona(row)"
          >
            <fa-icon class="si-icon" [icon]="['fal', 'pencil']"></fa-icon>
          </button>
        </div>
        <div class="ml-1 inline-block" [matTooltip]="row | buyerPersonasActionTooltip : isOpsAdminOrAdmin() : 'Delete'">
          <button
            mat-icon-button
            class="mat-error"
            [disabled]="((DELETE_LOADING_TAG | isLoadingById: row.id) | async) || row.isLocked || !isOpsAdminOrAdmin()"
            (click)="onDelete(row.id, index)"
          >
            <ng-container *ngIf="!((DELETE_LOADING_TAG | isLoadingById : row.id) | async); else loadingSpinnerTpl">
              <fa-icon class="si-icon" [icon]="['fal', 'trash-can']"></fa-icon>
            </ng-container>
          </button>
        </div>
      </ng-container>
    </app-data-table>
  }
}


<ng-template #loadingSpinnerTpl>
  <mat-spinner [diameter]="20"></mat-spinner>
</ng-template>
